export const ru = {
    'selected-groups-count': {
        one: 'Выбрана {count} категория',
        some: 'Выбрано {count} категории',
        many: 'Выбрано {count} категорий',
        none: 'Выбор категорий'
    },
    'video-preview-header': 'Предварительный просмотр',
    'video-title': 'Библиотека видеороликов'
};
